import {Component, Input} from '@angular/core';
import {MainMenuSection} from '../../../models/main-menu-section';
import {Router} from '@angular/router';
import {IndexPageSectionRouteENUM} from '../../../enums/index-page-section-route.enum';
import {Principal} from '../../../services/principal';
import {ModuleModeratorOptionsEnum} from '../../../enums/module-moderator-options.enum';
import {MainMenuPage} from '../../../models/main-menu-page';
import {MenuStructureSection} from '../../../../modules/admin/components/public-page/main-menu/menu-structure-edit-dialog/model/menu-section';
import {Utils} from '../../../services/Utils';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {

  private currentDate = new Date();

  constructor(private _router: Router,
              private _principal: Principal,
              public _utils: Utils) {
  }

  @Input() public sections: MainMenuSection[];
  @Input() public pages: MainMenuPage[];

  getNgClass(section): any {
    return {
      'fa-angle-down': section.subSectionList.length > 0 && !section.sectionID && !section.parentSubsectionID,
      'fa-angle-right': section.subSectionList.length > 0 && (section.sectionID || section.parentSubsectionID),
    };
  }

  showCollegeInfo(): boolean {
    // return true;
    return (this.sections && this.sections.length > 0 && this.sections[0].depth == 1);
  }

  markAsNew(section: MainMenuSection): boolean {
    if (section.new) {
      const expirationDate = new Date(section.expirationDate);
      expirationDate.setHours(0, 0, 0, 0);
      this.currentDate.setHours(0, 0, 0, 0);
      return this.currentDate <= expirationDate;
    }
    return false;
  }

  clickSection(section) {
    console.log('clickSection section', section);
    if (section.route) {
      if (section.route === ModuleModeratorOptionsEnum.ADD_PAGE_ROUTE) {
        this._router.navigate(['moderator/add-edit-page/' + section.sectionId]);
      } else if (section.route === ModuleModeratorOptionsEnum.ADD_SECTION_ROUTE) {
        this._router.navigate(['moderator/add-edit-section/' + section.sectionId]);
      } else {
        const type = IndexPageSectionRouteENUM[section.route];
        if (type) {
          this._router.navigate([type.route]);
        }

      }
    }
  }

  getMenuItems(sections: any[]) {
    const result = [];
    if (sections && sections.length > 0) {
      for (let i = 0; i < sections.length; i++) {
        const e: MenuStructureSection = sections[i];
        if (this._principal.isModerator() && !this.isModeratorRouteButton(e.route)) {
          if (e.moderatorsList && e.moderatorsList.findIndex(value => value.userId === this._principal.getUserId()) > -1) {
            // создаем ссылку "добавить страницу/раздел"
            const editMenuButton: any = this.fillModeratorButton(e);
            let needEditMenuButton = false;
            // устанавливаем флаг необходимости вставки ссылки на "добавить страницу/раздел" в конец меню раздела
            if (i === sections.length - 1 && e.depth > 1) {
              needEditMenuButton = true;
            }
            // добавляем ссылку на "добавить страницу" в подраздел если она пустая и не содержит эту же ссылку
            if (e.subSectionList && e.subSectionList.length === 0 && e.depth === 2 && !this.isModeratorRouteButton(e.route)) {
              if (e['pageId'] && e['pageId'] > 0) {
                needEditMenuButton = false;
              } else {
                e.subSectionList.push(editMenuButton);
              }
            }
          }
          result.push(e);
          // вставка ссылки на "добавить страницу/раздел" в конец меню раздела
          // if (needEditMenuButton) { result.push(editMenuButton); }
        } else {
          return sections;
        }
      }
    }
    return result;
  }

  fillModeratorButton(e): any {
    const editMenuButton: any = {};
    editMenuButton.id = null;
    // поумолчанию роут для ссылки "Добавить раздел"
    let name = ModuleModeratorOptionsEnum.ADD_SECTION_ROUTE;
    editMenuButton.sectionId = (e.sectionId ? e.sectionId : e.id);
    if (e.subSectionList && e.subSectionList.length === 0 && (e.depth === 2 || e.depth === 3)) {
      // если это подраздел раздела "Добавить страницу"
      name = ModuleModeratorOptionsEnum.ADD_PAGE_ROUTE;
      editMenuButton.sectionId = (e.parentSubsectionId ? e.parentSubsectionId : e.id);
    } else {
      if (e.pageId && e.pageId > 0) {
        // name = ModuleModeratorOptionsEnum.ADD_PAGE_ROUTE;
        editMenuButton.sectionId = e.subsectionId;
      }
    }
    editMenuButton.name = name;
    editMenuButton.nameKz = name;
    editMenuButton.nameRu = name;
    editMenuButton.nameEn = name;
    editMenuButton.route = name;
    editMenuButton.enable = true;
    editMenuButton.new = false;
    editMenuButton.parentSubsectionID = e.parentSubsectionId;
    editMenuButton.depth = e.depth;
    editMenuButton.subSectionList = [];
    return editMenuButton;
  }

  isModeratorRouteButton(route): boolean {
    return (route === ModuleModeratorOptionsEnum.ADD_PAGE_ROUTE || route === ModuleModeratorOptionsEnum.ADD_SECTION_ROUTE);
  }

  clickPageMenuItem(page: MainMenuPage) {
    if (page && page.id) {
      // console.log('MainMenuPage clickPageMenuItem page: ', page);
      this._router.navigate(['page/' + page.id]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/directives/menu/menu-item/menu-item.component.ts